/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import './styles.scss';
import { Divider } from 'antd-v5';
import { RightOutlined, EditOutlined } from '@ant-design/icons';

const QuickViewCard = ({
  children = null,
  borderColor,
  title,
  titleDescription,
  hasFooter,
  handleAction = () => { },
  actionText,
  actionStyles = {},
  footerEditText,
  handleEdit = () => { },
  hasViewMore = false,
  onViewMore = () => { },
  action = null,
  onClick = null,
  containerStyle = {},
  titleClassName = '',
  titleId = null,
  hasEdit = true,
  actionButton = null,
  dividerStyles = {},
}) => {
  return (
    <div
      className="quick-view-card"
      style={{
        borderLeftColor: borderColor,
        cursor: onClick ? 'pointer' : 'default',
        borderLeftWidth: borderColor ? 4 : 0,
      }}
      onClick={onClick || (() => { })}
    >
      <div className="flex-row justify-between w-100-P p-btm-8">
        <div className="flex-col-left" style={{ ...containerStyle }}>
          {title && (
            <h2 id={titleId} className={`quick-view-card-title ${titleClassName}`}>
              {title}
            </h2>
          )}
          {children}
        </div>
        <div className="flex-col-right gap-16 justify-between">
          <span className="fs-13" style={{ color: '#00000066' }}>
            {titleDescription}
          </span>
          {hasViewMore && <RightOutlined className="fs-18 pointer" onClick={onViewMore} />}
          {action}
        </div>
      </div>
      {hasFooter && (
        <>
          <Divider orientation="center" style={{ margin: '8px 0', ...dividerStyles }} />
          <div className="flex-row items-center justify-between">
            {actionButton || (
              <div style={{ color: '#33AAFC', ...actionStyles }} className="fw-500 pointer" onClick={handleAction}>
                {actionText || 'MESSAGE'}
              </div>
            )}
            {hasEdit && (
              <div
                className="flex-row items-center gap-8 pointer"
                style={{ color: '#7F7F7F80', '&:hover': { color: '#3D3D3D' } }}
                onClick={handleEdit}
              >
                <EditOutlined />
                {footerEditText}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default QuickViewCard;
